import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import Spinner from "react-bootstrap/Spinner";

import { Line } from "react-chartjs-2";
import CollapsibleCompanyItem from "./CollapsibleCompanyItem.jsx";
import AddDCA from "./AddDCA.jsx";
import "./Dashboard.css";
import ChartService from "services/chart-service.jsx";
import dcaSettingsService from "../../services/dashboard-stats-service";
import dashboardStatsService from "../../services/dashboard-stats-service";
// Added StatisticsBoxes import
import StatisticsBoxes from "components/common/StatisticsBoxes.jsx";
import { sortFunc } from "utils/helpers.js";
import DcaModal from "components/DCA/DcaModal.jsx";
import SellModal from "components/SellStocks/SellModal.jsx";

// Configurations for the case when no data available

function Dashboard() {
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("all");
  const [isChartDataLoading, setIsChartDataLoading] = useState(true);
  const [xAxisInterval, setXAxisInterval] = useState("1Y");
  const [labelsLength, setLabelsLength] = useState(0);
  const [labels, setLabels] = useState([]);
  const [dataset, setDataset] = useState([]);
  const [dcaOrders, setDcaOrders] = useState([]);
  const [dcaSettings, setDcaSettings] = useState([]);
  const [sellSettings, setSellSettings] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companiesShowGroup, setCompaniesShowGroup] = useState([0, 1, 2]);
  const [displayedCompanies, setDisplayedCompanies] = useState([]);
  const [displayedCompaniesLength, setDisplayedCompaniesLength] = useState(0);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [showAnalytics, setShowAnalytics] = useState(true);
  const [showAddDCA, setShowAddDCA] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [totalDCAInstructions, setTotalDCAInstructions] = useState(0);
  let [presentValue, setPresentValue] = useState(0);
  const [stockTotal, setStockTotal] = useState(0);
  const crosairPlugin = {
    id: "corsair",
    defaults: {
      width: 1,
      color: "#FF4949",
      dash: [2, 4],
    },
    afterInit: (chart, args, opts) => {
      chart.corsair = {
        x: 0,
        y: 0,
      };
    },
    afterEvent: (chart, args) => {
      const { inChartArea } = args;
      const { type, x, y } = args.event;

      chart.corsair = { x, y, draw: inChartArea };
      chart.draw();
    },

    beforeDatasetsDraw: (chart, args, opts) => {
      const { ctx, scales } = chart;
      const { top, bottom, left, right } = chart.chartArea;
      const { x, y, draw } = chart.corsair;
      // const newLabels = scales.x._labelItems.map(label => {
      //   const newLabel = { ...label };
      //   newLabel.options.textAlign = "right";
      //   return newLabel;
      // });
      // scales.x._labelItems = newLabels;

      if (!draw) return;

      ctx.save();

      ctx.beginPath();
      ctx.lineWidth = opts.width;
      ctx.strokeStyle = opts.color;
      ctx.setLineDash(opts.dash);
      ctx.moveTo(x, bottom);
      ctx.lineTo(x, top);
      ctx.moveTo(left, y);
      ctx.lineTo(right, y);
      ctx.stroke();

      ctx.restore();
    },
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
    crosairPlugin
  );

  // const cycle = (array, count, offset = 12) => {
  //   const output = [];
  //   let index1 = 0;
  //   let index2 = 0;
  //   for (var i = 0; i < 12 * count; i++) {
  //     if (index2 == offset) {
  //       index1++;
  //       index2 = 0;
  //     }
  //     output.push(array[index1]);
  //     index2++;
  //   }
  //   return output;
  // };

  // const calculateAverageGroup = (dataset0, groupSize) => {
  //   if (!dataset0) return;
  //   const updatedDataset = [];
  //   for (let i = 0; i < dataset0.length; i += groupSize) {
  //     const group = dataset0.slice(i, i + groupSize);
  //     const sum = group.reduce(
  //       (accumulator, currentValue) => accumulator + currentValue,
  //       0
  //     );
  //     const average = Math.ceil(sum / groupSize);
  //     updatedDataset.push(average);
  //   }
  //
  //   return updatedDataset;
  // };

  const getDataset = () => {
    // if (xAxisInterval === '6M') {
    //   return calculateAverageGroup(dataset, 12);
    // }

    // if (xAxisInterval === '1Y') {
    //   return calculateAverageGroup(dataset, 12);
    // }
    //
    if (xAxisInterval === "Max") {
      return dataset;
    }

    return dataset;
  };

  // Set how many points to show, to configure replace the second number in the slice() method with the max amount to display
  const MAX_DATA_TO_SHOW = -10;
  const data = {
    labels: labels.slice(MAX_DATA_TO_SHOW),
    datasets: [
      {
        fill: true,
        pointStyle: false,
        label: "",
        // Set how many points to show, to configure replace the second number in the slice() method with the max amount to display
        data: getDataset().slice(MAX_DATA_TO_SHOW),
        // borderWidth: 1,
        borderColor: "#511281",
        backgroundColor: ({ chart: { ctx } }) => {
          const bg = ctx.createLinearGradient(0, 0, 0, 400);
          bg.addColorStop(0, "#51128199");
          bg.addColorStop(1, "#1C193222");
          return bg;
        },
      },
    ],
  };

  const options = {
    // maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      corsair: {
        color: "#A5E1AD",
      },
    },

    //   noData,
    // ],

    hover: {
      mode: "index",
      intersect: false,
    },

    scales: {
      y: {
        // offset: true, // <-- This right here

        // min: 0,
        // max: 40000,

        position: "right",
        ticks: {
          // forces step size to be 3000
          stepSize: 2000,
          color: "#F8F8F8",
        },
        grid: {
          color: "rgba(76, 75, 86, 0.2)",
        },
      },
      x: {
        scaleLabel: {
          display: true,
          labelString: "Loading",
        },
        ticks: {
          align: "end",
          color: "#F8F8F8",
          autoSkip: true,
          maxTicksLimit: labelsLength,
        },

        grid: {
          color: "rgba(76, 75, 86, 0.2)",
        },
      },
    },
  };

  useEffect(() => {
    // console.log("dataset", dataset);
    ChartService.getData("/").then((res) => {
      const labels = res.map((item) => {
        return item.execution_date;
      });

      labels.sort((a, b) => a - b);

      if (labels.length === 1) {
        labels.unshift("Account created");
      }
      setLabels(labels);

      setLabelsLength(labels.length);
      // const dcaOrders = await ChartService.getData("/");
      //   Want to use dcaOrders outside the useEffect
      setDcaOrders(dcaOrders);
      setIsChartDataLoading(false);
    });
  }, [xAxisInterval]);

  useEffect(() => {
    const filteredCompanies = displayedCompanies.filter((company) => {
      const companyName = company.name?.toLowerCase() || "";
      const companyTicker = company.ticker?.toLowerCase() || "";
      return (
        companyName.includes(search.toLowerCase()) ||
        companyTicker.includes(search.toLowerCase())
      );
    });

    switch (sortBy) {
      case "newest":
        filteredCompanies.sort(
          (a, b) =>
            new Date(b["created_at"]).getTime() -
            new Date(a["created_at"]).getTime()
        );

        break;

      case "oldest":
        filteredCompanies.sort(
          (a, b) =>
            new Date(a["created_at"]).getTime() -
            new Date(b["created_at"]).getTime()
        );

        break;

      default:
        break;
    }
    // console.log(filteredCompanies);

    setFilteredCompanies(filteredCompanies);
    setDisplayedCompaniesLength(filteredCompanies.length || 0);
  }, [search, sortBy, displayedCompanies]);

  // total amount invested, present value, total dca instructions
  useEffect(() => {
    // ...

    const fetchData = async () => {
      try {
        const dcaSettings = await dashboardStatsService.getDCAsettings("/");
        // const dcaSettings = res; // Assuming `res` is the array of DCA settings
        setTotalDCAInstructions(dcaSettings.length);
        setDcaSettings(dcaSettings);
        setIsChartDataLoading(false);

        const dcaOrders = await ChartService.getData("/");
        // Want to use dcaOrders outside the useEffect
        setDcaOrders(dcaOrders);

        // Present Value
        // Step 1: Iterate over each unique ticker in totalData
        const uniqueTickers = [
          ...new Set(dcaOrders.map((data) => data.ticker)),
        ];

        let presentValue = 0;

        // Step 2-4: Calculate present value for each ticker and accumulate the values
        uniqueTickers.forEach((ticker) => {
          // Step 2: Find close_price from dcaSettings for the current ticker
          const dcaSetting = dcaSettings.find(
            (setting) => setting.ticker === ticker
          );

          // Check if dcaSetting is defined
          if (dcaSetting) {
            const closePrice = dcaSetting.last_close_price;

            // Step 3: Calculate sum of qty for the current ticker in totalData
            const sumQty = dcaOrders
              .filter((data) => data.ticker === ticker)
              .reduce((sum, data) => sum + data.qty, 0);
            // console.log("sumQty");
            // Step 4: Calculate present value for the current ticker
            const tickerPresentValue = closePrice * sumQty;
            // get the invested value
            dcaSetting.tickerInvestedValue = dcaOrders
              .filter((data) => data.ticker === ticker)
              .reduce((sum, data) => sum + data.amount, 0);
            // dcaSetting.tickerInvestedValue = tickerInvestedValue;
            // get the quantity purchased
            dcaSetting.qtyBought = sumQty;
            // get the quantity leftover
            dcaSetting.qtyLeftover =
              dcaSetting.total_max_quantity - dcaSetting.qtyBought;

            // presentValue += tickerPresentValue;

            // Accumulate the present values
            presentValue += tickerPresentValue;
          }
        });

        // Step 5: Set the final accumulated present value using setPresentValue
        setPresentValue(Math.round(presentValue));
      } catch (error) {
        console.log("Error fetching DCA settings:", error);
      }
    };

    fetchData();

    // ...
  }, []);

  // DCA Settings
  useEffect(() => {
    const calculateSum = (array, index) => {
      let sum = 0;
      for (let i = 0; i <= index; i++) {
        if (array[i] && array[i].amount) {
          sum += Math.round(array[i].amount);
        }
      }
      return sum;
    };

    let dataset1 = dcaOrders.map((item, index) => {
      let data;
      if (index) {
        data = calculateSum(dcaOrders, index);
      } else {
        data = item.amount || 0;
      }
      return data;
    });

    const totalStock = dataset1[dataset1.length - 1];
    setStockTotal(totalStock);

    if (dataset1.length === 1) {
      dataset1.unshift(0);
    }
    setDataset(dataset1);
    //
    // .catch((error) => {
    //   console.error("Error fetching data:", error);
    //   // Handle the error condition here
    // Update the companies data using dcaSetting
    // console.log("Companies");
    const updatedCompanies = dcaSettings.map((company) => {
      // console.log("company", company);
      const dcaSetting = dcaSettings.find(
        (setting) => setting.ticker === company.ticker
      );
      if (dcaSetting) {
        // console.log("DcaSetting", dcaSetting);
        const closePrice = dcaSetting.last_close_price;
        // convert max_order_quantity to int/float
        const qty = parseFloat(dcaSetting.qtyBought, 10) || 0;
        // console.log("qty", qty);
        // console.log("qty", typeof qty);
        const tickerPresentValue = closePrice * qty;
        // console.log("closePrice:", closePrice, typeof closePrice);
        // console.log("qty:", qty, typeof qty);
        // console.log("tickerPresentValue:", tickerPresentValue);
        return {
          ...company,
          presentValue: tickerPresentValue,
        };
      }
      return company;
    });
    setCompanies(updatedCompanies);
    const displayedCompanies = [];
    const iconBucket =
      "https://elasticbeanstalk-us-east-1-860729282963.s3.amazonaws.com/";

    for (let i = 0; i < updatedCompanies.length; i++) {
      const company = updatedCompanies[i];
      // console.log("company updated", company.tickerInvestedValue);

      displayedCompanies.push({
        logo: (
          <i className="bi" style={{ fontSize: "32px" }}>
            <img
              src={`${iconBucket}${company.ticker.toLowerCase()}.png`}
              onError={(e) => (e.target.src = `${iconBucket}default_stock.png`)}
              alt="Company Icon"
              width="32"
              height="32"
              // style={{ fill: "white" }}
            />
          </i>
        ),
        created_at: company.created_at,
        ticker: company.ticker,
        legalName: company.name,
        presentValue: parseInt(company.presentValue) || 0,
        investedValue: parseInt(company.tickerInvestedValue) || 0,
        qtyBought: company.qtyBought || 0,
        purchasePrice: (() => {
          const investedValue = parseInt(company.tickerInvestedValue) || 0;
          const qtyBought = company.qtyBought || 0;

          if (
            investedValue === 0 ||
            qtyBought === 0 ||
            isNaN(investedValue) ||
            isNaN(qtyBought)
          ) {
            return 0;
          } else {
            return (investedValue / qtyBought).toFixed(2);
          }
        })(),
        qtyLeftover:
          parseInt(company.qtyBought) === 0 &&
          parseInt(company.total_max_quantity) !== 0
            ? company.total_max_quantity
            : company.qtyLeftover,
        netPL:
          `${(
            ((parseInt(company.presentValue) || 0) /
              (parseInt(company.tickerInvestedValue) || 0) -
              1) *
            100
          ).toFixed(2)}`.replace(/NaN/g, "0") + "%",
        progressBar: (company.qtyBought * 100) / company.total_max_quantity,
        // Broker
        broker: company.selectBroker || "Email Notifications",
      });
      // console.log("Invested Value:", company);
    }
    // console.log("Invested Value:", parseInt(company.tickerInvestedValue));
    setDisplayedCompanies(displayedCompanies);
    setDisplayedCompaniesLength(displayedCompanies.length || 0);
    // console.log("displayedCompanies:", displayedCompanies);
  }, [dcaSettings, dcaOrders]);
  // console.log("displayedCompanies2", DisplayedCompanies);
  const getOrDefault = (data, defaultData) => {
    // console.log("inside getordefault", data);
    /* Used to check the returned data and return the passed defaultData if data is null or empty */
    if (data && data.hasOwnProperty("length") && data.length !== 0) {
      return data;
    }

    return defaultData;
  };

  const handleSearch = (eve) => {
    setSearch(eve.target.value);
    setCompaniesShowGroup([0, 1, 2]);
  };

  const handleClickPreviousCompanies = (eve) => {
    if (companiesShowGroup[0] <= 1) return;
    setCompaniesShowGroup(companiesShowGroup.map((value) => value - 3));
  };

  const handleClickNextCompanies = (eve) => {
    if (companiesShowGroup[2] >= displayedCompaniesLength - 1) return;
    setCompaniesShowGroup(companiesShowGroup.map((value) => value + 3));
  };

  const canClickNext = () => {
    return companiesShowGroup[2] < displayedCompaniesLength - 1;
  };

  const canClickPrevious = () => {
    return companiesShowGroup[0] >= 1;
  };
  // console.log("going into return");

  return (
    <>
      {/* View Switcher for mobile view */}
      <section className="mb-0 mt-5 d-lg-none">
        <Container>
          <Row className="mx-4 switchers">
            <Col
              className={"switcher " + (showAnalytics ? "active-switcher" : "")}
              onClick={() => {
                setShowAnalytics(true);
              }}
            >
              Dashboard
            </Col>
            <Col
              className={"switcher " + (showAnalytics ? "" : "active-switcher")}
              onClick={() => {
                setShowAnalytics(false);
              }}
            >
              My investments
            </Col>
          </Row>
        </Container>
      </section>

      {/* Summary Section */}
      <section
        id="summary-section"
        className={"mt-5 " + (showAnalytics ? "d-block" : "d-none d-lg-block")}
      >
        {/* Rendering StatisticsBoxes component and passing to it array containing objects with "title" and "value" variables */}
        <StatisticsBoxes
          arrayOfStatistics={[
            {
              title: "Smart DCA Instructions",
              value: dcaSettings.length,
            },
            { title: "Amount Invested", value: stockTotal },
            { title: "Market Value", value: presentValue },
          ]}
        />
      </section>

      {/* Chart Section */}
      <section
        id="chart-section"
        className={showAnalytics ? "d-block" : "d-none d-lg-block"}
      >
        <Container>
          <Row>
            {/* Interval Switchers */}
            <Col sm={12} className="d-flex">
              <h4 className="">{dataset.length > 0 && "Amount Invested"}</h4>

              <div className="ms-5 ms-lg-auto me-4 d-flex align-items-center x-axis-interval overflow-scroll-sm">
                {/* <div>
                  <span className={ xAxisInterval=="1D" ? "text-celadon" : undefined } onClick={(e) => {setXAxisInterval("1D")}}>1D</span>
                </div>
                <div>
                  <span className={ xAxisInterval=="5D" ? "text-celadon" : undefined } onClick={(e) => {setXAxisInterval("5D")}}>5D</span>
                </div>
                <div>
                  <span className={ xAxisInterval=="1M" ? "text-celadon" : undefined } onClick={(e) => {setXAxisInterval("1M")}}>1M</span>
                </div>
                <div>
                  <span className={ xAxisInterval=="6M" ? "text-celadon" : undefined } onClick={(e) => {setXAxisInterval("6M")}}>6M</span>
                </div>
                <div>
                  <span className={ xAxisInterval=="1Y" ? "text-celadon" : undefined } onClick={(e) => {setXAxisInterval("1Y")}}>1Y</span>
                </div>
                <div>
                  <span style={{ cursor: "default" }}>5Y</span>
                </div> */}
                <div>
                  <span
                    className={
                      xAxisInterval == "Max" ? "text-celadon" : undefined
                    }
                    onClick={(e) => {
                      setXAxisInterval("Max");
                    }}
                  ></span>
                </div>
              </div>
            </Col>

            {/* Line Chart */}
            <Col sm={12} className="mb-5">
              {isChartDataLoading ? (
                <div className="w-100 d-flex justify-content-center py-5">
                  <Spinner />
                </div>
              ) : labels.length > 0 ? (
                <Line options={options} data={data} />
              ) : (
                <div className="w-100 d-flex justify-content-center py-5">
                  <h3 className="text-center">
                    {" "}
                    {/*Monitoring patiently to invest.<br/>*/}
                    Your investments will show up here.
                  </h3>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Companies Section */}
      <section
        id="companies-section"
        className={"mt-5 " + (showAnalytics ? "d-none d-lg-block" : "d-block")}
      >
        <Container>
          <Row>
            {/* Table */}
            <Col sm={12}>
              <h4 className="mb-4">Companies you invested in</h4>

              {/* Controllers */}
              <Col className="d-block d-lg-flex gap-3 mb-4">
                <InputGroup
                  size="sm"
                  className="dark-input mb-3 mb-lg-auto w-auto"
                >
                  <InputGroup.Text id="search-input-label">
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    id="search-input"
                    aria-label="search"
                    aria-describedby="search-input-label"
                    placeholder="Search Now"
                    name="Search"
                    value={search}
                    onChange={handleSearch}
                  />
                </InputGroup>

                <Dropdown className="dark-dropdown mb-3 mb-lg-auto">
                  <Dropdown.Toggle className="">Sort by</Dropdown.Toggle>
                  <Dropdown.Menu className="">
                    <Dropdown.Item
                      eventKey="1"
                      className="d-flex"
                      onClick={(eve) => {
                        setSortBy("newest");
                      }}
                    >
                      From new to old{" "}
                      <i
                        className={
                          "ps-3 ms-auto bi " +
                          (sortBy === "newest"
                            ? "bi-record-circle-fill"
                            : "bi-circle")
                        }
                      ></i>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      className="d-flex"
                      onClick={(eve) => {
                        setSortBy("oldest");
                      }}
                    >
                      From old to new{" "}
                      <i
                        className={
                          "ps-3 ms-auto bi " +
                          (sortBy === "oldest"
                            ? "bi-record-circle-fill"
                            : "bi-circle")
                        }
                      ></i>
                    </Dropdown.Item>

                    <Dropdown.Item
                      eventKey="4"
                      className="d-flex"
                      onClick={(eve) => {
                        setSortBy("all");
                      }}
                      record-circle-fill
                    >
                      All{" "}
                      <i
                        className={
                          "ps-3 ms-auto bi " +
                          (sortBy === "all"
                            ? "bi-record-circle-fill"
                            : "bi-circle")
                        }
                      ></i>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <button
                  className="btn btn-primary btn-block btn-full full-width-sm"
                  onClick={() => {
                    setShowAddDCA(true);
                  }}
                >
                  <i className="bi bi-plus"></i> Add SMART DCA
                </button>
                {/*<button*/}
                {/*  className="btn btn-primary btn-block btn-full full-width-sm"*/}
                {/*  onClick={() => {*/}
                {/*    setShowSellModal(true);*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <i className="bi bi-plus"></i> Add SMART Sell*/}
                {/*</button>*/}

                <div className="ms-auto d-none d-lg-block">
                  <button
                    className={
                      "me-1 btn navigator " +
                      (canClickPrevious() && "active-navigator")
                    }
                    onClick={handleClickPreviousCompanies}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <button
                    className={
                      "ms-1 btn navigator " +
                      (canClickNext() && "active-navigator")
                    }
                    onClick={handleClickNextCompanies}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </div>
              </Col>

              {/* Table header */}
              <Col className="d-none d-lg-flex justify-content-between lighter-section px-4">
                <Col sm={3}>Company</Col>
                <Col sm={1}>Market Value</Col>
                <Col sm={1}>Invested</Col>
                <Col sm={1}>Quantity</Col>
                <Col sm={1}>Quantity Left</Col>
                <Col sm={1}>Purchase Price</Col>
                <Col sm={1}>Profit/Loss</Col>
                <Col sm={1}>Broker</Col>
              </Col>

              <Col>
                <Container>
                  <Row className="companies d-block">
                    {/* Table body */}
                    {getOrDefault(
                      filteredCompanies.map((company, index) => (
                        <Col
                          id={`company-${index}`}
                          key={index}
                          className={
                            "justify-content-between align-items-center lighter-section px-4 mt-4 py-4" +
                            " " +
                            (companiesShowGroup.includes(index)
                              ? "d-block"
                              : "d-lg-none")
                            // for displaying only three companies at the same time
                          }
                        >
                          <CollapsibleCompanyItem company={company} />
                        </Col>
                      )),
                      <Col
                        id="company-empty"
                        className="d-flex justify-content-center align-items-center lighter-section px-4 mt-4 py-4"
                      >
                        No company was found
                      </Col>
                    )}
                  </Row>
                </Container>
              </Col>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* <AddDCA show={showAddDCA} setShow={setShowAddDCA} /> */}
      <DcaModal
        show={showAddDCA}
        setShow={setShowAddDCA}
        setDcaData={setDcaSettings}
        isShowEditModal={false}
        dcaData={{}}
      />
      <SellModal
        show={showSellModal}
        setShow={setShowSellModal}
        setSellData={setSellSettings}
        isShowEditModal={false}
        sellData={{}}
      />
    </>
  );
}

export default Dashboard;
